// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'bb.token';
export const REFRESH_TOKEN_COOKIE = 'bb.refreshToken';
export const BADGES_STORAGE_KEY = 'bb.badges';
export const VERSION = 'v4.0.079';
